import React from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import { brandColors } from '../Color/Color'
import { fontLetterSpacings, fontLineHeights, fontSizes } from '../Typography/TypographyStyles'

interface LoadingBackdropProps {
  message?: string
}

const LoadingBackdrop: React.FC<LoadingBackdropProps> = ({ message }) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 1, // Ensure this is higher than the modal
        position: 'fixed', // Fixed position to cover the viewport
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
      open={true} // Always open when rendering this component
    >
      <CircularProgress sx={{ color: brandColors.greenTelus, size: '1.25rem' }} />
      {message && (
        <Typography
          sx={{
            marginLeft: 2,
            fontSize: fontSizes.size20,
            lineHeight: fontLineHeights.ratio9to8,
            letterSpacing: fontLetterSpacings.loose,
          }}
        >
          {message}
        </Typography>
      )}
    </Backdrop>
  )
}

export default LoadingBackdrop
